<template>
    <v-layout fill-height>
        <div id="myMap"></div>
        <div class="mapTools" v-if="activeMapTool == 'draw'">
            <div v-show="toolInfo">{{ toolInfo }}</div>
            <v-tooltip bottom>
                <template #activator="{ on }">
                    <button v-on="on" @click="updateActivetool('delete')" class="btn-icon icon-trash" :class="{'active': activeToolMode === 'delete'}"></button>
                </template>
                Löschen
            </v-tooltip>
            <v-tooltip bottom>
                <template #activator="{ on }">
                    <button v-on="on" @click="updateActivetool('deselect')" class="btn-icon icon-deselect" :class="{'active': activeToolMode === 'deselect'}"></button>
                </template>
                Auswahl aufheben
            </v-tooltip>
            <v-btn
                    @click="updateActivetool('save')"
                    class="sr-button"
                    :class="{'active': activeToolMode === 'save'}"
                    :loading="drawLoading"
                    :disabled="drawLoading"
                    text
            >
                Speichern
            </v-btn>
        </div>
        <div class="mapTools" v-else-if="activeMapTool == 'measure'">
            <div v-show="toolInfo">{{ toolInfo }}</div>
            <v-tooltip bottom>
                <template #activator="{ on }">
                    <button v-on="on" @click="updateActivetool('select')" class="btn-icon icon-mode-select" :class="{'active': activeToolMode === 'select'}"></button>
                </template>
                Auswahl
            </v-tooltip>
            <v-tooltip bottom>
                <template #activator="{ on }">
                    <button v-on="on" @click="updateActivetool('draw')" class="btn-icon icon-mode-draw" :class="{'active': activeToolMode === 'draw'}"></button>
                </template>
                Zeichnen
            </v-tooltip>
            <v-tooltip bottom>
                <template #activator="{ on }">
                    <button v-on="on" @click="updateActivetool('delete')" class="btn-icon icon-trash" :class="{'active': activeToolMode === 'delete'}"></button>
                </template>
                Löschen
            </v-tooltip>
        </div>
        <div class="map-switch">
            <v-switch
                    class="sr-switch"
                    @change="switchMapStyle"
                    label="Satellite"
            ></v-switch>
        </div>
    </v-layout>
</template>

<script>
  import MapHelper from './MapHelper'
  import GeoObject from '@/models/GeoObject'
  import GeoObjectAPI from '@/api/geoObject'
  import GeoObjectCollection from '@/models/GeoObjectCollection'
  import GeoObjectCollectionFooter from '@/components/toolbox/geoobjectcollection/Footer'
  import GeoObjectCollectionHeader from '@/components/toolbox/geoobjectcollection/Header'
  import _ from 'lodash'
  import GeoObjectStore from '@/components/geoview/GeoObjectStore'

  export default {
    props: {
      layers: {
        type: Array
      },
      mapConfig: {
        type: Object,
        required: true
      },
      activeMapTool: {
        type: String,
        required: true
      },
      filterConfig: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        map: null,
        toolInfo: '',
        activeMapLayers: [],
        drawLoading: false,
        activeToolMode: 'select'
      }
    },
    mounted () {
      this.map = new MapHelper({
        mapId: 'myMap',
        bounds: this.mapConfig.bounds,
        zoom: this.mapConfig.zoom,
        onBoundsUpdate: this.onBoundsUpdate,
        onZoomUpdate: this.onZoomUpdate,
        activeTool: this.activeMapTool,
        $dialog: this.$dialog,
        onObjectsSelect: this.onObjectsSelect,
        onToolError: (error) => this.$alert.error(error),
        onToolSave: (id, data) => {
          this.drawLoading = true
          GeoObjectAPI.updateVector(id, data).then(() => {
            this.drawLoading = false
            this.updateActivetool('select')
            this.map.updateLayerSources({ filter: this.filterConfig, searchParams: this.searchParams, mode: this.searchMode })
            this.$alert.success('Erfolgreich gespeichert')
          }).catch((error) => {
            this.drawLoading = false
            this.$alert.error('Fehler beim speichern')
            return error
          })
        },
        onToolInfo: this.onToolInfo,
        onLoad: () => {
          for (let i = 0; i < this.layers.length; i++) {
            if (typeof this.layers[i - 1] !== 'undefined') {
              this.addLayer(this.layers[i], this.layers[i - 1])
            } else {
              this.addLayer(this.layers[i])
            }
          }
          this.map.selectedFeatures(this.getActiveObjects)
        },
        transformRequest: (url, resourceType) => {
          if (resourceType === 'Source' && url.startsWith(process.env.VUE_APP_API_ENDPOINT)) {
            return {
              url: url,
              headers: { 'X-Session-Id': this.$store.getters['auth/getSessionId'] }
            }
          }
        }
      })
    },
    methods: {
      updateActivetool (value) {
        let oldMode = this.activeToolMode
        this.activeToolMode = value
        this.map.updateActivetool(value)
        if (value === 'delete' || value === 'deselect') {
          this.activeToolMode = oldMode
        }
      },
      onZoomUpdate (zoomLevel) {
        this.$emit('zoomUpdate', zoomLevel)
      },
      onBoundsUpdate (bounds) {
        this.$emit('boundsUpdate', bounds)
      },
      async onObjectsSelect (objects) {
        switch (this.activeMapTool) {
          case 'pointer':
            this.$store.dispatch('geoview/addActiveObject', { id: objects.id, source: objects.source })
            return this.$toolbox.open({
              item: new GeoObject(objects),
              onConfirm: (toolbox) => {
                // hier die daten zum server senden
                // toolbox.contentData gibt das item zurück (GeoObjectCollection)
                return GeoObjectAPI.udpate(toolbox.contentData.id, toolbox.contentData)
              },
              onConfirmError: (toolbox, error) => {
                // hier den fehler in die toolbox setzen
                toolbox.errorData = error.response.data.error
                this.$alert.info('Es sind Fehler beim speichern aufgetreten')
              }
            }).then((result) => {
              this.$store.dispatch('geoview/removeActiveObject', { id: objects.id })
              if (typeof result.content === 'object' && result.content) {
                if (typeof result.content.isDeleted !== 'undefined' && result.content.isDeleted) {
                  this.$alert.success('Erfolgreich gelöscht')
                  this.map.updateLayerSources({ filter: this.filterConfig, searchParams: this.searchParams, mode: this.searchMode })
                }
              }
              if (result.confirmed) {
                this.$alert.success('Erfolgreich gespeichert')
              }
            }).catch((error) => {
              this.$store.dispatch('geoview/removeActiveObject', { id: objects.id })
              this.$alert.error('Leider lief etwas schief')

              return error
            })
          case 'create':
            return this.$toolbox.open({
              item: new GeoObjectCollection(objects, this.layers),
              layoutOptions: {
                footerComponent: GeoObjectCollectionFooter,
                headerComponent: GeoObjectCollectionHeader
              },
              onConfirm: (toolbox) => {
                // hier die daten zum server senden
                // toolbox.contentData gibt das item zurück (GeoObjectCollection)
                return GeoObjectAPI.create(toolbox.contentData)
              },
              onConfirmError: (toolbox, error) => {
                // hier den fehler in die toolbox setzen
                toolbox.errorData = error.response.data.error
                this.$alert.info('Es sind Fehler beim erstellen aufgetreten')
                return error
              }
            }).then((result) => {
              console.log('TEST: TB result', result);
              if (result.confirmed) {
                this.$alert.success('Erfolgreich erstellt')
                this.map.updateLayerSources({ filter: this.filterConfig, searchParams: this.searchParams, mode: this.searchMode })
              }

              this.map.resetSelection()
            }).catch((error) => {
              this.$alert.error('Leider lief etwas schief')

              return error
            })
          default:
        }
      },
      addLayer (layer, beforeLayer) {
        if (this.activeMapLayers.indexOf(layer.id) > -1) {
          // existiert bereits
          this.map.moveLayer(layer, beforeLayer)
          return
        }

        this.activeMapLayers.push(layer.id)
        this.map.addLayer(layer, { searchParams: this.searchParams, mode: this.searchMode }, beforeLayer)
      },
      removeLayer (layer) {
        if (this.activeMapLayers.indexOf(layer.id) > -1) {
          this.activeMapLayers.splice(this.activeMapLayers.indexOf(layer.id), 1)
          this.map.removeLayer(layer)
        }
      },
      switchMapStyle (isSatellite) {
        if (isSatellite) {
          this.map.setMapStyle('satellite', this.layers[this.layers.length - 1])
        } else {
          this.map.setMapStyle('street')
        }
      },
      onToolInfo (value) {
        this.toolInfo = value
      }
    },
    computed: {
      getActiveObjects () {
        return this.$store.getters['geoview/getActiveObjects']
      },
      getCenter () {
        return this.$store.getters['geoview/getCenter']
      },
      searchParams () {
        return this.$store.getters['search/getSearches']
      },
      searchMode () {
        return this.$store.getters['search/getSearchMode']
      }
    },
    watch: {
      layers (newVal, oldVal) {
        // sync layers
        if (typeof oldVal !== 'undefined') {
          const missingLayers = _.differenceBy(oldVal, newVal, 'id')
          for (let layer of missingLayers) {
            this.removeLayer(layer)
          }
        }
        for (let i = 0; i < newVal.length; i++) {
          if (typeof newVal[i - 1] !== 'undefined') {
            this.addLayer(newVal[i], newVal[i - 1])
          } else {
            this.addLayer(newVal[i])
          }
        }
      },
      filterConfig (newVal) {
        if (typeof this.map !== 'undefined') {
          this.map.updateLayerSources({ filter: newVal, searchParams: this.searchParams, mode: this.searchMode })
        }
      },
      searchParams (newVal) {
        if (typeof this.map !== 'undefined') {
          this.map.updateLayerSources({ filter: this.filterConfig, searchParams: newVal, mode: this.searchMode })
        }
      },
      searchMode (newVal) {
        if (typeof this.map !== 'undefined') {
          this.map.updateLayerSources({ filter: this.filterConfig, searchParams: this.searchParams, mode: newVal })
        }
      },
      activeMapTool (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.activeToolMode = 'select'
        }
        this.map.setActiveTool(newVal, oldVal)
      },
      getActiveObjects (newVal) {
        this.map.selectedFeatures(newVal)
      },
      getCenter (newVal) {
        this.map.setCenter(newVal)
      }
    }
  }
</script>

<style scoped>
    #myMap {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .mapTools {
        position: absolute;
        right: 50px;
        bottom: 50px;
    }
</style>
